import { useHasRole } from '~/shared/context/use-has-role';

// The roles the realtime service grants CAN_USE_AGENT_CHAT. A plain `user` holds none of them, so
// a surface reachable without a job-architecture role checks this before offering the chat.
export const AGENT_CHAT_ROLES: readonly string[] = [
    'job_architect',
    'reviewer',
    'viewer',
    'user_manager',
    'talent_developer',
];

export const useCanUseAgentChat = (): boolean => useHasRole(...AGENT_CHAT_ROLES);
